module.exports = __webpack_public_path__ + "img/9788901101132.44fd6dcb.jpg";